'use strict';

function compareBy(f, a, b) {
  var a_ = f(a);
  var b_ = f(b);

  if (a_ > b_) {
    return 1;
  } else if (a_ < b_) {
    return -1;
  } else {
    return 0;
  }
}

module.exports = compareBy;
